export * from "./atoms";
export * from "./layouts";
export * from "./molecules";
export * from "./organisms";
// Future Ideas:
//
// src/
// └── design-system --> (v2) /
//     ├── foundations/           # raw tokens, utilities, theming
//     │   ├── colors.ts
//     │   ├── spacing.ts
//     │   └── typography.ts
//     │
//     ├── atoms/                 # smallest building blocks
//     │   ├── Button/
//     │   │   ├── Button.tsx
//     │   │   └── Button.stories.tsx
//     │   ├── Link/
//     │   ├── Icon/
//     │   └── Card/              # you can also split Card into Atom vs. Molecule variants
//     │
//     ├── molecules/             # simple compositions of atoms
//     │   ├── InputGroup/        # e.g. label + input + help text
//     │   ├── Tabs/              # tab list + tab items + underline indicator
//     │   └── StackCard/         # a vertical stack of Card + Header + Actions
//     │
//     ├── organisms/             # larger UI sections
//     │   ├── FilterBar/         # Tabs + search box + dropdown
//     │   ├── TerminalList/      # FilterBar + list of TerminalListItem cards
//     │   └── RecommendationList/ # heading + list of RecommendationCard
//     │
//     ├── patterns/              # reusable layouts & higher-level sections
//     │   ├── DashboardSection/  # Section title + optional controls + body
//     │   ├── StatsGrid/         # 3-col grid of StatCard
//     │   └── SidebarLayout/     # left nav + content area
//     │
//     └── utils/                 # shared hooks, helpers, theme-aware style utils
